export default "__VITE_PUBLIC_ASSET__84d168f5__"